import React, { useState } from "react";
import InstructorHomepage from "./instructorHome";
import Permissions from "./Permissions";
import Report from "./Report";
import Leaves from "./Leaves";
import Settings from "./settings";
import Devices from "./Devices";
import { StaffGroupProvider, STAFF_GROUPS } from "./StaffGroupContext";
import StarStaff from "../../../../../components/attendanceAppreciation/StarStaff";

const SwitchTabs = () => {
  const [step, setStep] = useState(1);
  const [group, setGroup] = useState("instructor");

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <InstructorHomepage />
          </div>
        );
      case 2:
        return (
          <div>
            <Permissions />
          </div>
        );
      case 3:
        return (
          <div>
            <Leaves />
          </div>
        );

      case 4:
        return (
          <div>
            <Report />
          </div>
        );

      case 5:
        return (
          <div>
            <Devices />
          </div>
        );

      case 6:
        return (
          <div>
            <Settings />
          </div>
        );

      case 7:
        return (
          <div>
            <StarStaff />
          </div>
        );

      default:
        return (
          <div>
            <InstructorHomepage />
          </div>
        );
    }
  }

  return (
    <>
      {/* {subject.isSuccess ? ( */}
      <div className="p-8">
        {/* Instructors are reviewed separately from support staff & drivers. */}
        <div className="flex gap-3 mb-4">
          {STAFF_GROUPS.map((g) => (
            <button
              key={g.value}
              type="button"
              onClick={() => setGroup(g.value)}
              className={`px-4 py-2 rounded-full border text-sm font-medium ${
                group === g.value
                  ? "bg-gray-600 text-white border-gray-600 shadow"
                  : "bg-white text-gray-700 border-gray-300"
              }`}
            >
              {g.label}
            </button>
          ))}
        </div>
        {/*
          Inline grid rather than `grid grid-cols-6`: the Tailwind class is
          generated correctly, but the compiled stylesheet served locally was
          not picking up this newly-added utility. Inline styles are immune to
          that, so the tab row lays out regardless of CSS build state.
        */}
        <div
          className="bg-white rounded-lg"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
          }}
        >
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Home</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Permissions</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${
              step === 3 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Leaves</div>
          </div>
          <div
            onClick={() => setStep(4)}
            className={`iskool-tab-item ${
              step === 4 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Reports</div>
          </div>
          <div
            onClick={() => setStep(5)}
            className={`iskool-tab-item ${
              step === 5 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Devices</div>
          </div>
          <div
            onClick={() => setStep(6)}
            className={`iskool-tab-item ${
              step === 6 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Settings</div>
          </div>
          <div
            onClick={() => setStep(7)}
            className={`iskool-tab-item ${
              step === 7 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Star Staff</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          {/* key remounts the tab on a switch, so a filter or selection from
              one group can't linger into the other. */}
          <StaffGroupProvider group={group}>
            <div key={group}>{switchTab()}</div>
          </StaffGroupProvider>
        </div>
      </div>
    </>
  );
};

export default SwitchTabs;
